export default "__VITE_ASSET__BnjqTW_b__"